import * as swcHelpers from '@swc/helpers';
import { persistReducer, actions, localStorage } from '@grandvisionhq/state';
import { setPreferredShippingMethod } from './actions.js';

const initialState = {
    preferredMethodKey: null
};
const reducer = actions.reducer(initialState, /**
   * Storing user's preferred shipping method.
   * Currently this is the last shipping method selected by the user in the checkout/cart
   */ actions.on(setPreferredShippingMethod, (s, { payload: { shippingMethodKey  }  })=>swcHelpers.objectSpread({}, s, {
        preferredMethodKey: shippingMethodKey
    })
));
const persistConfig = {
    storage: localStorage,
    key: 'grandvision_shipping'
};
var shippingReducer = persistReducer(persistConfig, reducer);

export { shippingReducer as default, initialState, reducer };
//# sourceMappingURL=reducer.js.map
